import { useCallback } from 'react';
import { getAutomationStack } from '@atlassian/jira-automation-platform';
import { useService } from '@atlassian/jira-common-services/src/use-service';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { fetchJson, isClientFetchError, isHttpClientErrorResponse } from '@atlassian/jira-fetch';
import { useProject } from '@atlassian/jira-router-resources-business-project-details';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';

export const useAutomationRulesService = () => {
	const { environment, cloudId } = useTenantContext();
	const { data: project } = useProject();
	const projectId = String(project?.id);

	const fetchRules = useCallback(async () => {
		try {
			const automationStack = await getAutomationStack(environment, cloudId);

			return fetchJson(
				`/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rules`,
				{
					method: 'POST',
					body: JSON.stringify({
						limit: 10,
						offset: 0,
						sortKey: 'NAME',
						sortOrder: 'ASC',
					}),
				},
			);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			if (!isClientFetchError(error) && !isHttpClientErrorResponse(error)) {
				fireErrorAnalytics({
					meta: {
						id: 'fetchIssueTypes',
						packageName: 'jiraMoonExperimentAutomationDiscoveryOnBoardColumns',
						teamName: 'jira-warepil',
					},
					error,
					sendToPrivacyUnsafeSplunk: false,
				});
			}
			throw error;
		}
	}, [cloudId, environment, projectId]);

	const { fetch, error, loading, data } = useService(fetchRules);
	return { fetch, error, loading, data };
};
